/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 *
 * Konami code implementation under the BSD Zero Clause license
 * https://gist.github.com/cyyynthia/8009319c5dd381e16031604f9d820cae
 */

import everybodyDoTheFlop from './assets/videos/everybody-do-the-flop.mp4'

// Hack to not be annoyed by number vs NodeJS.Timeout shenanigans
type Timeout = ReturnType<typeof setTimeout>

const keys: string[] = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'B',
  'A',
]

let current: number = 0
let timeout: Timeout | null = null

window.addEventListener('keydown', (e) => {
  if (timeout) {
    clearTimeout(timeout)
    timeout = null
  }

  // If modifier is pressed, ignore
  if (e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) {
    current = 0
    return
  }

  // Check the sequence
  const k = e.key.length > 1 ? e.key : e.key.toUpperCase()
  if (keys[current] === k) {
    current++
  }

  // We got the code!
  if (keys.length === current) {
    current = 0
    onKonamiCode()
  } else {
    // Consider the attempt abandoned if no key is pressed within a second
    timeout = setTimeout(() => {
      current = 0
      timeout = null
    }, 1e3)
  }
})

function onKonamiCode() {
  const app = document.getElementById('app')
  const v = document.createElement('video')
  v.setAttribute('style', 'position:absolute;inset:0;width:100vw;height:100vh;object-fit:cover')
  v.src = everybodyDoTheFlop

  app!.style.display = 'none'
  document.body.appendChild(v)

  void v.play()
  v.addEventListener('ended', () => {
    v.remove()
    app!.style.display = ''
  })
}
